<app-layout>
  <app-voltar route="listagem/entrada-gate" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <app-subtitulo *ngIf="isMode === 0">
      Informe os dados do motorista e confirme para realizar entrada do veículo
    </app-subtitulo>
    <app-subtitulo *ngIf="isMode === 3"> Visualização da entrada do veículo </app-subtitulo>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form" (ngSubmit)="$event.preventDefault()">
      <div *ngIf="isMode === 3">
        <h3 class="section-title">Dados do agendamento</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Data do Agendamento"
            name="DT_AGND"
            formControlName="DT_AGND"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Turno"
            name="TURNO"
            formControlName="TURNO"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Janela"
            name="JANELA"
            formControlName="JANELA"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Valor Pré-Pátio"
            name="VL_PRE_PTIO"
            formControlName="VL_PRE_PTIO"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="number"
            label="N° Agendamento"
            name="FK_AGND"
            formControlName="FK_AGND"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>
        <h3 class="section-title">Dados da Nota</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Nota Fiscal"
            name="TX_NOTA_FISCAL"
            formControlName="TX_NOTA_FISCAL"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Volume"
            name="NU_VOLUME"
            formControlName="NU_VOLUME"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Peso (Ton)"
            name="NU_PESO_TON"
            formControlName="NU_PESO_TON"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Produto"
            name="NM_CRGA"
            formControlName="NM_CRGA"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Destinatário"
            name="NM_DEST"
            formControlName="NM_DEST"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>
        <h3 class="section-title">Dados da Transportadora</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Nome"
            name="NM_TPTD"
            formControlName="NM_TPTD"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="CNPJ"
            name="TX_CNPJ_TPTD"
            formControlName="TX_CNPJ_TPTD"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Contato"
            name="TX_CNTT_TPTD"
            formControlName="TX_CNTT_TPTD"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>
        <h3 class="section-title">Dados do Cliente</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Nome"
            name="NM_CLNT"
            formControlName="NM_CLNT"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>
        <h3 class="section-title">Dados do Caminhão</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Placa Cavalo"
            name="TX_PLCA_CAVA"
            formControlName="TX_PLCA_CAVA"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Carreta 1"
            name="TX_PLCA_CRRT1"
            formControlName="TX_PLCA_CRRT1"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Carreta 2"
            name="TX_PLCA_CRRT2"
            formControlName="TX_PLCA_CRRT2"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Carreta 3"
            name="TX_PLCA_CRRT3"
            formControlName="TX_PLCA_CRRT3"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>
        <h3 class="section-title">Dados do Motorista</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Nome do Motorista"
            name="NM_USUA_MTRT"
            formControlName="NM_USUA_MTRT"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="CPF"
            name="TX_CPF_MTRT"
            formControlName="TX_CPF_MTRT"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Contato"
            name="NU_TELE_MTRT"
            formControlName="NU_TELE_MTRT"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>
        <h3 class="section-title">Dados do Acompanhante</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Acompanhante"
            name="NM_ACPN"
            formControlName="NM_ACPN"
            [disabled]="true"
            placeholder="Sem acompanhante"
          ></app-input>
          <app-input
            type="text"
            label="Vínculo"
            name="TX_VNCL_MTRT"
            formControlName="TX_VNCL_MTRT"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Data de Nascimento"
            name="DT_NASC_ACPN"
            formControlName="DT_NASC_ACPN"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Documento"
            name="TX_DOC_VNCL"
            formControlName="TX_DOC_VNCL"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>
        <h3 class="section-title">Operador que realizou o agendamento</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Nome"
            name="NM_OPER"
            formControlName="NM_OPER"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Contato"
            name="NU_TELE_OPER"
            formControlName="NU_TELE_OPER"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>

        <h3 class="section-title">Operador que deu entrada no pátio</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Nome"
            name="NM_FUNC_OPER"
            formControlName="NM_FUNC_OPER"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>

        <div class="formList">
          <app-input
            type="textarea"
            class="full-width"
            label="Observação"
            name="TX_OBSV_GATE_ENTR"
            formControlName="TX_OBSV_GATE_ENTR"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>
        <div class="formList" *ngIf="flCancelado">
          <app-input
            type="textarea"
            class="full-width"
            label="Motivo do cancelamento"
            name="TX_MOTV_CNCL_GATE_ENTR"
            [ngModel]="motivoCancelamento || '---'"
            [ngModelOptions]="{ standalone: true }"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>
        <div class="footer-actions" *ngIf="podeRegistrarSaida()" style="display: flex; gap: 1rem; margin-top: 1rem;">
          <app-botao
            type="cadastro"
            text="Registrar Saída"
            (click)="navegarSaida()"
          ></app-botao>
        </div>
      </div>

      <div *ngIf="isMode !== 3">
        <h3 class="section-title">Dados do agendamento</h3>
        <div class="formList">
          <app-input
            type="number"
            label="N° Agendamento"
            name="FK_AGND"
            formControlName="FK_AGND"
            [disabled]="camposBloqueadosPorAgendamento"
            placeholder="Insira o número do agendamento, se houver"
            (blurEvent)="buscarAgendamento()"
          ></app-input>
          <app-input
            type="text"
            label="Data do Agendamento"
            name="DT_AGND"
            formControlName="DT_AGND"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Turno"
            name="TURNO"
            formControlName="TURNO"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Janela"
            name="JANELA"
            formControlName="JANELA"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <div class="aviso-pre-patio" *ngIf="avisoPrePatio">
            {{ avisoPrePatio }}
          </div>
          <app-input
            type="text"
            label="Valor Pré-Pátio"
            name="VL_PRE_PTIO"
            formControlName="VL_PRE_PTIO"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>
        <h3 class="section-title">Dados do Caminhão</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Placa Cavalo"
            name="TX_PLCA_CAVA"
            formControlName="TX_PLCA_CAVA"
            [requiredInput]="true"
            (blurEvent)="buscarCaminhaoParams()"
            mask="AAA0A00"
            [disabled]="camposBloqueadosPorAgendamento"
            placeholder="Digite aqui"
          ></app-input>
        </div>
        <h3 class="section-title">Dados da Nota Fiscal</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Nota Fiscal"
            name="TX_NOTA_FISCAL"
            formControlName="TX_NOTA_FISCAL"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Volume"
            name="NU_VOLUME"
            formControlName="NU_VOLUME"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Peso (Ton)"
            name="NU_PESO_TON"
            formControlName="NU_PESO_TON"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Produto"
            name="NM_CRGA"
            formControlName="NM_CRGA"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Destinatário"
            name="NM_DEST"
            formControlName="NM_DEST"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>

        <h3 class="section-title">Dados da Transportadora</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Nome"
            name="NM_TPTD"
            formControlName="NM_TPTD"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="CNPJ"
            name="TX_CNPJ_TPTD"
            formControlName="TX_CNPJ_TPTD"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Contato"
            name="TX_CNTT_TPTD"
            formControlName="TX_CNTT_TPTD"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>
        <h3 class="section-title">Dados do Motorista</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Nome do Motorista"
            name="NM_USUA_MTRT"
            formControlName="NM_USUA_MTRT"
            [disabled]="camposBloqueadosPorAgendamento"
            placeholder="Digite aqui"
            (blurEvent)="buscarMotoristaPorNome()"
          ></app-input>
          <app-input
            type="text"
            label="CPF"
            name="TX_CPF_MTRT"
            formControlName="TX_CPF_MTRT"
            mask="000.000.000-00"
            [disabled]="camposBloqueadosPorAgendamento"
            placeholder="Digite aqui"
          ></app-input>
          <app-input
            type="text"
            label="Contato"
            name="NU_TELE_MTRT"
            formControlName="NU_TELE_MTRT"
            mask="(00) 0000-0000||(00) 00000-0000"
            [disabled]="camposBloqueadosPorAgendamento"
            placeholder="Digite aqui"
          ></app-input>
        </div>

        <h3 class="section-title">Dados do Acompanhante</h3>
        <div class="formList">
          <app-input
            type="text"
            label="Acompanhante"
            name="NM_ACPN"
            formControlName="NM_ACPN"
            [disabled]="true"
            placeholder="Sem acompanhante"
          ></app-input>
          <app-input
            type="text"
            label="Vínculo"
            name="TX_VNCL_MTRT"
            formControlName="TX_VNCL_MTRT"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Data de Nascimento"
            name="DT_NASC_ACPN"
            formControlName="DT_NASC_ACPN"
            [disabled]="true"
            placeholder="---"
          ></app-input>
          <app-input
            type="text"
            label="Documento"
            name="TX_DOC_VNCL"
            formControlName="TX_DOC_VNCL"
            [disabled]="true"
            placeholder="---"
          ></app-input>
        </div>

        <div class="formList">
          <app-input
            type="textarea"
            class="full-width"
            label="Observação"
            name="TX_OBSV_GATE_ENTR"
            formControlName="TX_OBSV_GATE_ENTR"
            [disabled]="camposBloqueadosPorAgendamento"
            placeholder="Digite aqui"
          ></app-input>
        </div>
      </div>
      <app-botao
        type="cadastro"
        text="Confirmar Entrada"
        class="botao-cadastro"
        buttonType="button"
        (click)="abrirModal()"
        *ngIf="isMode === 0"
        [disabled]="!form.valid"
      ></app-botao>
    </form>
  </div>

  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
